import { ACustomAnimate } from "@visactor/vrender-core";

export class GroupFadeIn extends ACustomAnimate {
    constructor(from, to, duration, easing) {
        super(null, null, duration, easing);
    }
    getEndProps() {
        return {};
    }
    onBind() {
        this.target.setTheme({
            common: {
                opacity: 0
            }
        });
    }
    onEnd() {
        this.target.setTheme({
            common: {
                opacity: 1
            }
        });
    }
    onUpdate(end, ratio, out) {
        this.target.setTheme({
            common: {
                opacity: ratio
            }
        });
    }
}

export class GroupFadeOut extends ACustomAnimate {
    constructor(from, to, duration, easing) {
        super(null, null, duration, easing);
    }
    getEndProps() {
        return {};
    }
    onBind() {
        this.target.setTheme({
            common: {
                opacity: 1
            }
        });
    }
    onEnd() {
        this.target.setTheme({
            common: {
                opacity: 0
            }
        });
    }
    onUpdate(end, ratio, out) {
        this.target.setTheme({
            common: {
                opacity: 1 - ratio
            }
        });
    }
}
//# sourceMappingURL=group-fade.js.map
